//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getDiscount from '~/components/Products/getDiscount';
import {
  SfSidebar,
  SfButton,
  SfList,
  SfIcon,
  SfHeading,
  SfMenuItem,
  SfFilter,
  SfProductCard,
  SfProductCardHorizontal,
  SfPagination,
  SfAccordion,
  SfSelect,
  SfBreadcrumbs,
  SfLoader,
  SfColor,
  SfProperty,
  SfAddToCart,
  SfImage,
  SfHero,
  SfChevron
} from '@storefront-ui/vue';
import Sku from '~/components/Sku/Sku';
import { computed, useRouter, ref, onMounted } from '@nuxtjs/composition-api';
import { useOCart, useWishlist, productGetters,categoryGetters, useFacet, facetGetters, useApiError, useCategoryTree, useGoodsSearch } from '@bee-hole/coms';
import { useUiHelpers, useUiState } from '~/composables';
import { onSSR } from '@vue-storefront/core';
import LazyHydrate from 'vue-lazy-hydration';
import CategoryPageHeader from '~/components/CategoryPageHeader';
import { addBasePath } from '@vue-storefront/core';
import { useCache, CacheTagPrefix } from '@bee-hole/cache';


// TODO(addToCart qty, horizontal): https://github.com/vuestorefront/storefront-ui/issues/1606
export default {
  transition: 'fade',
  setup(props, context) {
    const router = useRouter();
    const { set: setError } = useApiError();
    const { search: searchProduct, goodsResult, loading } = useGoodsSearch('cat-goods');
    const { catTreeGet, catTrees, loading: catLoading } = useCategoryTree('CategoryTree');
    const th = useUiHelpers();
    const uiState = useUiState();
    const { addItem: addItemToCart, isInCart } = useOCart();
    const { addItem: addItemToWishlist, isInWishlist, removeItem: removeItemFromWishlist, wishlist } = useWishlist();
    const { result, error, search: searchList } = useFacet('cat-goods');
    const selectedCount = ref({});
    const MouseoverProduct = ref();
    // const pagination = computed(() => facetGetters.getPagination(result.value));
    const pagination = computed(() => {
      return {
        currentPage: th.getFacetsFromURL().page || 1,
        totalPages: Math.ceil((goodsResult?.value?.total || 0) / 12) || 0,
        totalItems: goodsResult?.value?.total || 0,
        itemsPerPage: 12,
        pageOptions: []
      };
    });
    const productsQuantity = ref({});
    const categoryTree = computed(() => facetGetters.getCategoryTree(result.value));
    const breadcrumbs = computed(() => facetGetters.getBreadcrumbs(result.value));
    const products = computed(() => {
      if (!goodsResult.value) {
        return [];
      }
      return facetGetters.getProducts({ data: { list: goodsResult.value.list }});
    });
    const selectedSku = {};
    const changeSelectedSku = (res) => {
      selectedSku[res.goodId] = res.sku;
    };
    const activeCategory = computed(() => {
      let items = catTrees.value;
      if (!items || !items.length) {
        return context.root.$t('See_all');
      }
      let category = items.find((cat) => (cat && cat?.catId === parseInt(th.getFacetsFromURL().catId)));
      return category?.name || context.root.$t('See_all');
    });
    const activeSubCategory = computed(() => {
      let items = catTrees.value;
      if (!items || !items.length) {
        return context.root.$t('See_all');
      }
      let category = items.find((cat) => (cat && cat?.catId === parseInt(th.getFacetsFromURL().catId)));
      let subCategory = category?.subCats.find((subCat) => (subCat && subCat?.catId === parseInt(th.getFacetsFromURL().subCatId)));
      return subCategory?.name || context.root.$t('All');
    });
    const goCategory = (catName) => {
      let pathStr = '';
      // 遍历categories.value，找到catName对应的catId
      if (catName === 'all') {
        pathStr = `/c/0/all`;
      } else {
        const cat = catTrees.value.find((item) => item.name === catName);
        // var subCat = null
        pathStr = `/c/${cat.catId}/${categoryGetters.getSlug(cat)}`;
      }
      ///${subCat.name}?sc=${subCat.catId}
      // if (cat.subCats?.length){
      //   subCat = cat.subCats[1]
      //   pathStr += `/${subCat.name}?sc=${subCat.catId}`
      // }
      router.push(context.root.localePath(pathStr));
    };

    const addItemForWishlist = (product) => {
      if (product.product.skus.length > 1) {
        router.push(context.root.localePath(`/p/${product.product.goodId}/${productGetters.getSlug(product.product)}`));
      } else {
        product.product.skuId = product.product.skus[0].skuId;
        addItemToWishlist(product);
      }
    };

    const removeProductFromWishlist = (productItem) => {
      const product = wishlist.value.list.find(wishlistProduct => wishlistProduct.goodId === productItem.goodId);
      removeItemFromWishlist({ product });
    };
    const addCartGoogle =(product)=>{
      const sku = product.skus?.[0]
      const googleCartItem ={
        currency: context?.root?.$cookies?.get('vsf-currency'),
        value: sku.price,
        items: [
          {
            item_id: product.goodId,
            item_name: product.title,
            price: sku?.price,
            quantity: 1,
            item_variant: '',
          },
        ],
      }
      context.root.$gtm.push(
      {
        event: "add_to_cart",
        ecommerce: googleCartItem
      });
    }
    const addToCart = (product) => {
      if (!selectedSku[product.product.goodId]) {
        setError({ message: 'please select sku', code: 50 });
        return false;
      }
      const p = {};
      p.sku = selectedSku[product.product.goodId];
      p.num = selectedCount.value[product.product.goodId] ? selectedCount.value[product.product.goodId] : 1;
      if (p.sku && p.sku.skuId) {
        addItemToCart({ customQuery: { skuId: p.sku.skuId }, product: { goodId: product.product.goodId }, quantity: p.num });
      } else {
        setError({ message: 'none sku', code: 50 });
      }
    };
    const addToCart1 = ({ product, quantity }) => {
      if (product?.skus?.length === 1) {
        const p = {};
        addCartGoogle(product)
        addItemToCart({
          product,
          quantity
        });
      } else {
        // ${product.slug || product.title}
        router.push(context.root.localePath(`/p/${product.goodId}/${productGetters.getSlug(product)}`));
      }

    };

    const { addTags } = useCache();
    onSSR(async () => {
      var query = {
        limit: 12,
        page: th.getFacetsFromURL().page,
        // catId: th.getFacetsFromURL().catId,
        // subCatId: th.getFacetsFromURL().subCatId,
        sort: th.getFacetsFromURL().sort
      }
      if (th.getFacetsFromURL().subCatId && th.getFacetsFromURL().subCatId != 0){
        query.catId = th.getFacetsFromURL().subCatId
        query.cat_id = th.getFacetsFromURL().subCatId
      }else{
        query.catId = th.getFacetsFromURL().catId
        query.cat_id = th.getFacetsFromURL().catId
      }
      await searchProduct(query);
      await catTreeGet({ cat_id: query.catId });
      // await searchList(query);
      // await searchCat({});
      // products.value.map(function (item){
      //   selectedCount[item.goodId] = 1
      // })
      // console.log("ctx===========", context.root.$options.$storeConfig);

      if (result?.value?.data?.list?.length === 0) {
        // context.root.$nuxt.error({ statusCode: 404, title: 'cat_items_null', description: 'cat_items_null_des' });
      } else if (error?.value?.search) {
        context.root.$nuxt.error({ statusCode: 404 });
      } else {
        try {
          addTags([
            { prefix: CacheTagPrefix.Category, value: 'category', dataPrefix: context.root.$options.$storeConfig?.mall_cache_pre }
          ]);
        } catch (e) {
          console.log("addTags error:", e);
        }
      }
    });
    const handlerMouseoverProduct = (product) => {
      MouseoverProduct.value = product;
    };
    const handlerMouseleaveProduct = (product) => {
      if (MouseoverProduct.value?.goodId === product.goodId) {
        MouseoverProduct.value = null;
      }
    };
    const changeCategoryView = () => {
      MouseoverProduct.value = null;
    };
    onMounted(async () => {
    });
    return {
      ...uiState,
      th,
      products,
      categoryTree,
      loading,
      productGetters,
      categoryGetters,
      pagination,
      activeCategory,
      goCategory,
      breadcrumbs,
      addItemForWishlist,
      addItemToWishlist,
      removeProductFromWishlist,
      isInWishlist,
      addToCart,
      isInCart,
      productsQuantity,
      addBasePath,
      changeSelectedSku,
      selectedCount,
      addToCart1,
      selectedSku,
      handlerMouseoverProduct,
      MouseoverProduct,
      handlerMouseleaveProduct,
      changeCategoryView,
      catTrees,
      catLoading,
      activeSubCategory
    };
  },
  components: {
    CategoryPageHeader,
    SfButton,
    SfSidebar,
    SfIcon,
    SfList,
    SfFilter,
    SfProductCard,
    SfProductCardHorizontal,
    SfPagination,
    SfMenuItem,
    SfAccordion,
    SfSelect,
    SfBreadcrumbs,
    SfLoader,
    SfColor,
    SfHeading,
    SfProperty,
    LazyHydrate,
    Sku,
    SfAddToCart,
    SfImage,
    SfHero,
    getDiscount,
    SfChevron
  }
};
